import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'

const Status: React.FC<MemberProps<ILineItem>> = ({ member }) => {
  const { tRecordType } = ToolBox.useString()

  const { machineStatus } = member

  const status: { [key in IMachineStatus]: string } = {
    extended: 'green',
    extend_requested: 'blue',
    extend_rejected: 'red',
    vacant: 'green',
    unconfirmed: 'orange'
  }

  const translate = React.useMemo(
    () => machineStatus && tRecordType(RecordType.line_item, `machine_status.${machineStatus}`),
    [machineStatus]
  )

  const title =
    machineStatus &&
    tRecordType(
      RecordType.line_item,
      `machine_status.${machineStatus}_title`,
      {},
      { defaultMessage: ' ' }
    ).trim()

  return (
    <If condition={machineStatus}>
      <Tooltip title={title}>
        <KTag icon={<InfoCircleOutlined />} text={translate} color={status[machineStatus]} />
      </Tooltip>
    </If>
  )
}

export default Status
